var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dh-psy-read-more"},[_c('Esi',{attrs:{"src":_vm.universeSrc}}),_vm._v(" "),_c('Esi',{attrs:{"src":_vm.generalSrc,"beforeHTML":_vm.generalBeforeHTML,"afterHTML":_vm.generalAfterHTML}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }